import twemoji from "twemoji";
import "./emoji.css";

// Version figée du package "twemoji" installé (voir package.json).
// On sert les SVG depuis cdnjs plutôt que le CDN par défaut de twemoji,
// qui n'est plus maintenu de façon fiable.
const TWEMOJI_VERSION = "14.0.2";
const TWEMOJI_BASE = `https://cdnjs.cloudflare.com/ajax/libs/twemoji/${TWEMOJI_VERSION}/`;

/**
 * Affiche un emoji sous forme d'image SVG (Twemoji) plutôt que via le
 * caractère Unicode natif, dont le rendu dépend de la police système et
 * varie selon l'OS/le navigateur de l'utilisateur (voir ListeAudits.js).
 */
const Emoji = ({ symbol, className = "", style }) => (
  <span
    className={`emoji-icon ${className}`}
    style={style}
    role="img"
    aria-label={symbol}
    dangerouslySetInnerHTML={{
      __html: twemoji.parse(symbol, {
        folder: "svg",
        ext: ".svg",
        base: TWEMOJI_BASE,
      }),
    }}
  />
);

export default Emoji;
